<template>
  <div class="contactUs">
    <MdCase  class="MD"/>
    <PcCase class="PC"/>
  </div>
</template>

<script>
// 移动端
import MdCase from './MdCase.vue'
// pc端
import PcCase from './PcCase.vue'
// 引入获取解决方案类型
// import { homeCustomer,customerCase,customerCaseType,customerCaseInfo } from '@/api/client'

export default {
  name: 'contactUs',
  components: {
    MdCase,
    PcCase
  },
  mounted () {
    // this.homeCustomer()
    // this.customerCaseType()
    // this.customerCase({ID:1})
    // this.customerCaseInfo({ id: 8})
  },
  methods: {
    // 首页
    // async homeCustomer () {
    //   const res = await homeCustomer()
    //   // console.log(res, 'homeCustomerhomeCustomer')
    //   // if (res.Msg === '获取成功') {
    //   //   this.$store.commit('homeCustomer', res.Data)
    //   // }
    // },

        // 获取客户案例类型
    // async customerCaseType () {
    //   const res = await customerCaseType()
    //   if (res.Msg === '获取成功') {
    //     this.$store.commit('getCaseTitle', res.Data)
    //   }
    // },
    //     // 客户案例中心
    // async customerCase (data) {
    //   const res = await customerCase(data)
    //   console.log(res, 'customerCasecustomerCase')
    //   // if (res.Msg === '获取成功') {
    //   //   this.$store.commit('homeCustomer', res.Data) 
    //   // }
    // },
    //     // 客户案例详情
    // async customerCaseInfo (data) {
    //   const res = await customerCaseInfo(data)
    //   console.log(res, 'customerCaseInfocustomerCaseInfo')
    //   // if (res.Msg === '获取成功') {
    //   //   this.$store.commit('homeCustomer', res.Data)
    //   // }
    // }
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .contactUs{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .contactUs{
    .MD{
      display: none;
    }
  }
}
</style>
